<div class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md">
    <div class="trezo-card-header mb-[20px] md:mb-[25px] flex items-center justify-between">
        <div class="trezo-card-title">
            <h5 class="!mb-0">
                Additional Information
            </h5>
        </div>
    </div>
    <div class="trezo-card-content">
        <ul>
            <li class="mb-[12.5px] last:mb-0">
                Phone:
                <span class="text-black dark:text-white font-medium">
                    +1 444 266 5599
                </span>
            </li>
            <li class="mb-[12.5px] last:mb-0">
                Address:
                <span class="text-black dark:text-white font-medium">
                    84 S. Arrowhead Court Branford
                </span>
            </li>
            <li class="mb-[12.5px] last:mb-0">
                Orders:
                <span class="text-black dark:text-white font-medium">
                    696
                </span>
            </li>
            <li class="mb-[12.5px] last:mb-0">
                Products:
                <span class="text-black dark:text-white font-medium">
                    9240
                </span>
            </li>
            <li class="mb-[12.5px] last:mb-0">
                Events:
                <span class="text-black dark:text-white font-medium">
                    5
                </span>
            </li>
        </ul>
    </div>
</div>